import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfSendIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * CcfSendIcon used to disply send icon
 * @param props - CcfSendIconProps
 * @example -- <CcfSendIcon />
 */
export function CcfSendIcon(props: CcfSendIconProps) {
  return (
    <SvgIcon width="20" height="22" viewBox="0 0 20 22" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7755 1.97886C19.8945 1.56177 19.7108 1.17267 19.4499 0.950649C19.1907 0.730129 18.7656 0.606773 18.3772 0.850394L1.38782 9.78219C0.942407 9.96464 0.765956 10.3895 0.822836 10.7738C0.878248 11.1482 1.15368 11.505 1.58932 11.614L1.61034 11.6192L9.50593 12.8077L12.054 20.3413L12.0566 20.3482C12.2179 20.7788 12.6074 21.0097 12.9932 21.0097C13.3809 21.0097 13.7732 20.7721 13.895 20.3154L19.7735 1.98592L19.7755 1.97886ZM9.84676 10.8748L4.855 10.1343L14.9311 4.85973L9.84676 10.8748ZM12.9593 16.9599L11.336 12.131L16.4382 6.0948L12.9593 16.9599Z"
        fill={props.fillColor ? props.fillColor : props.fill? props.fill : '#007AB8'}
      />
    </SvgIcon>
  );
}

export default CcfSendIcon;
